import { Suspense, useEffect } from 'react';
import { Outlet, useLocation, useNavigationType } from 'react-router-dom';
import { PageLoader } from '../../ui';
import { useIsMobile } from '../../lib/hooks';
import { AuthDialog } from '../../features/auth/AuthDialog';
import { PageErrorBoundary } from '../ErrorBoundary';
import { Header } from './Header';
import { Footer } from './Footer';
import styles from './SiteLayout.module.css';

/** Scroll to top on new pages; leave the browser's restored position on back/forward. */
function ScrollManager() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === 'POP') return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, navigationType]);

  return null;
}

export function SiteLayout() {
  const { pathname } = useLocation();
  const isMobile = useIsMobile();

  const isLanding = pathname === '/';
  // The app download page is designed as a full-screen experience on phones.
  const bare = isMobile && pathname.startsWith('/apps');

  return (
    <div className={styles.shell}>
      <ScrollManager />
      <a href="#main" className={styles.skip}>
        Skip to content
      </a>
      {!bare && <Header overlay={isLanding} />}
      <main id="main" className={styles.main}>
        <PageErrorBoundary key={pathname}>
          <Suspense fallback={<PageLoader label="Loading…" minHeight="70vh" />}>
            <Outlet />
          </Suspense>
        </PageErrorBoundary>
      </main>
      {!bare && <Footer />}
      <AuthDialog />
    </div>
  );
}
